import { format } from "date-fns";

// const aesjs = require("aes-js");
// var Buffer = require("buffer/").Buffer;
const salt = process.env.REACT_APP_CRYPTO_KEY;

// export function encrypt(input) {
//   let keyString = salt;
//   const key = keyString.trim();
//   const value = input.trim();
//   const keyBuffer = aesjs.utils.utf8.toBytes(key);
//   const inputBuffer = aesjs.padding.pkcs7.pad(aesjs.utils.utf8.toBytes(value));

//   const escEcb = new aesjs.ModeOfOperation.ecb(keyBuffer);
//   const encryptedBytes = escEcb.encrypt(inputBuffer);

//   const encryptedData = Buffer.from(encryptedBytes).toString("base64");
//   return encryptedData;
// }

export function formatDateToTimestamp(date) {
  return (
    date.getFullYear() +
    "-" +
    String(date.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(date.getDate()).padStart(2, "0") +
    " " +
    String(date.getHours()).padStart(2, "0") +
    ":" +
    String(date.getMinutes()).padStart(2, "0") +
    ":" +
    String(date.getSeconds()).padStart(2, "0") +
    "." +
    String(date.getMilliseconds()).padStart(3, "0")
  );
}

export const getLocalDateTime = (date) =>
  format(new Date(date), "yyyy-MM-dd'T'HH:mm:ss");

// export function decrypt(input) {
//   const aesjs = require("aes-js");
//   var Buffer = require("buffer/").Buffer;
//   const salt = process.env.REACT_APP_CRYPTO_KEY;
//   const key = salt.trim();
//   let data;

//   data = input.trim();

//   const keyBuffer = aesjs.utils.utf8.toBytes(key);
//   const escEcb = new aesjs.ModeOfOperation.ecb(keyBuffer);
//   const buf = Buffer.from(data, "base64");
//   const decryptedBytes = escEcb.decrypt(buf);
//   const decryptedText = aesjs.utils.utf8.fromBytes(decryptedBytes);

//   const regex = /[\u{0001}-\u{0010}]/gu;

//   const result = regex.test(decryptedText)
//     ? decryptedText.replace(/[\u{0001}-\u{0010}]/gu, "")
//     : decryptedText;
//   return result.trim();
// }

export function getCurrentDateTime() {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = now.getFullYear();
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

export const checkLinkExpiry = (timestamp) => {
  let linkDate = new Date(timestamp);
  if (linkDate instanceof Date && !isNaN(linkDate.getTime())) {
    linkDate.setDate(linkDate.getDate() + 30);

    console.log("future date", linkDate, timestamp);
    let today = new Date();
    if (today <= linkDate) {
      console.log("if", today, linkDate);
      return false;
    } else {
      console.log("else", today, linkDate);
      return true;
    }
  } else {
    return false;
  }
};
